/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("homePageModule", [
    "homePageRouter",
    "homeInformationModule", //公告详情
]).
controller("homePageCtrl", ["$scope", "$state", "$q", "httpService", '$filter', 'localStorageService', function($scope, $state, $q, httpService, $filter, localStorageService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            copyCurrPage: 1,
            useId: ''
        };
        $scope.data = {
            listData: [],
            selectedArray: [], //选中的数据
            memoryRead: {}, //存储已读

        };

        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: 12,
            PAGECOUNT: 1,
            ITEMCOUNT: 0
        };
        $scope.params = {
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        };

    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        useId().then(function() {
            requestData();
        });

    }
    /**
     * [requestData description] 初始化列表数据
     */
    function requestData() {
        var read = localStorageService.get("read");
        $scope.data.selectedArray = read ? (read[$scope.status.useId] ? read[$scope.status.useId] : []) : [];
        /*var params = {
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        };*/
        $scope.loadingPromise = httpService.http("/mcnww/web/notice/noticeList.do", $scope.params, "get").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        });
    }
    /**
     * [dateFormat description] 时间格式化
     * @return {[type]} [description]
     */
    $scope.dateFormat = function(item) {
        item.pubTime = !!item.pubTime ? $filter("date")(item.pubTime, "yyyy-MM-dd HH:mm:ss").toString() : "";
    };
    /**
     * [selectPageNum description]选择分页条数
     * @return {[type]} [description]
     */
    $scope.selectPageNum = function() {
        $scope.params.currPage = $scope.page.CURRPAGE;
        $scope.params.pageSize = $scope.page.PAGESIZE;
        $scope.status.copyCurrPage = 1;
        requestData();
    };
    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.params.currPage = $scope.page.CURRPAGE;
        $scope.status.copyCurrPage = $scope.page.CURRPAGE;
        requestData();
    };
    /**
     * [jumpToPage description:跳转指定页面]
     */
    $scope.jumpToPage = function() {
        if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
            $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
        }
        $scope.params.currPage = $scope.status.copyCurrPage;
        $scope.page.CURRPAGE = $scope.status.copyCurrPage;
        requestData();
    };


    /**
     * [gotoTop description点击分页后，回到头部]
     * @return {[type]} [description]
     */
    function gotoTop() {
        $('html, body').animate({ scrollTop: 0 }, 'nomal');
    }
    /**
     * [selectDoc description] 记录已读公告
     * @return {[type]} id [description]
     */
    $scope.selectDoc = function(item) {
        $scope.data.selectedArray.push(item.id);
        $scope.data.memoryRead[$scope.status.useId] = $scope.data.selectedArray;
        localStorageService.set("read", $scope.data.memoryRead);

        var href = $state.href("homeinformation");
        window.open(href + "?id=" + item.id + "&type=3");
    };
    /**
     * [useId description] 用户id
     * @return {[type]} id [description]
     */
    function useId() {
        var deffer = $q.defer();
        httpService.http("/mcnww/web/user/getLoginUser.do", "", "post").then(function(data) {
            $scope.status.useId = data.loginUser.id;
            deffer.resolve();
        });
        return deffer.promise;
    };
}]);
